var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapMark2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.8187 0.00422007 5.7689 1.26986 3.51938 3.51938C1.26986 5.7689 0.00422007 8.8187 0 12C0 20.615 11.18 31.405 11.655 31.86C11.7474 31.9498 11.8712 32 12 32C12.1288 32 12.2526 31.9498 12.345 31.86C12.82 31.405 24 20.615 24 12C23.9958 8.8187 22.7301 5.7689 20.4806 3.51938C18.2311 1.26986 15.1813 0.00422007 12 0ZM12 17.5C10.9122 17.5 9.84883 17.1774 8.94436 16.5731C8.03989 15.9687 7.33495 15.1098 6.91866 14.1048C6.50238 13.0998 6.39346 11.9939 6.60568 10.927C6.8179 9.86011 7.34172 8.8801 8.11091 8.11091C8.8801 7.34172 9.86011 6.8179 10.927 6.60568C11.9939 6.39346 13.0998 6.50238 14.1048 6.91866C15.1098 7.33494 15.9687 8.03989 16.5731 8.94436C17.1774 9.84883 17.5 10.9122 17.5 12C17.4991 13.4584 16.9194 14.8569 15.8881 15.8881C14.8569 16.9194 13.4584 17.4991 12 17.5Z",
    fill: "#0044EB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMark2);
export default __webpack_public_path__ + "static/media/icon_map_mark_2.104a895decd6c6b46eec80dda2529ce5.svg";
export { ForwardRef as ReactComponent };